module.exports = __webpack_public_path__ + "static/media/pando_branches_logo.7d3a3b7b.png";